import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAnalysisContext } from '../../contexts/AnalysisContext';
import { reportTransitionCenter, ReportTransitionI } from '../../services/analysis';
import formatNumber from '../../utils/formatNumber';
import If from '../../components/If/If';
import useFetch from './analisysHook';
import formatDate from '../../utils/formatDate';

interface Props {
  pageNumber: number,
  onLoading?: (isLoading: boolean) => void
  largePageName?: string
  isPrintAll?: boolean
  printYear?: string
  printToYear?: string
  printFromMonth?: string
  printToMonth?: string
}

const ReportAllCard: React.FC<Props> = ({
  pageNumber, onLoading, largePageName, isPrintAll, printYear, printToYear, printFromMonth, printToMonth,
}) => {
  // name: 全体成績表（中央値）の推移
  const {
    textSize, currentDataYear, currentDataToYear, currentDataToMonth, currentDataFromMonth,
  } = useAnalysisContext();
  const { data, gettingData, farmName } = useFetch<ReportTransitionI>(reportTransitionCenter, isPrintAll, onLoading);
  const shouldRender = (data: ReportTransitionI) => data && data.data;

  const calcs = {
    1: [5, 59, 57, 56, 54, 55, 71, 72, 52, 51, 47, 73],
    2: [43, 45, 46, 53, 44, 67, 61, 50, 48, 76, 74],
    3: [60, 75, 66, 63, 69, 65, 62, 64, 68, 58, 70],
  };

  const monthSentence = () => {
    const fromMonth = printFromMonth ?? currentDataFromMonth;
    const toMonth = printToMonth ?? currentDataToMonth;

    if (fromMonth === toMonth) {
      return `各年、${fromMonth}月分の集計となります。`;
    }
    return `各年、
            ${printFromMonth ?? currentDataFromMonth}
          月～
            ${printToMonth ?? currentDataToMonth}
    月の集計となります。`;
  };

  return (
    <>
      <If test={gettingData}>
        <div className="text-center p-5">
          <Spinner animation="border" />
        </div>
      </If>
      <section id="reportTransition1" style={{ display: gettingData ? 'none' : 'block' }}>
        <div className="page-break-before" />

        <div className="mt-2 row">
          <div className="flex-fill text-sm-start col-4">
            農場ID:
            {farmName}
          </div>
          <div className="flex-fill text-sm-center fw-bold col-4">
            全体成績表（中央値）の推移【No.
            {pageNumber}
            】
          </div>
          <div className="flex-fill text-sm-end text-sm col-4">
            {largePageName}
          </div>
        </div>
        <div className="border-bottom my-1" />
        <div className="table-responsive">
          <div style={{ fontSize: '0.8rem', color: '#FF0000' }}>
            {monthSentence()}
          </div>
          <table
            className={`table align-middle table-striped table-standard table-bordered table-tbody-nowrap table-sm text-sm-print text-${textSize}`}
            id="tblTransition1"
          >
            <thead>
              <tr>
                <th>年</th>

                {
                  data && data.labels
                  && calcs[pageNumber as keyof typeof calcs].map((calc: number) => <th key={calc}>{data.labels[`calc${calc}`].name}</th>)

              }
              </tr>
            </thead>
            <tbody>
              {
                !data
                && (
                <tr>
                  <td colSpan={11} className="text-center">データはありません。</td>
                </tr>
                )
            }
              {
                shouldRender(data) && Object.entries(data.data).map((value) => (
                  <tr key={value[0]}>
                    <td>{value[0]}</td>
                    {
                          data && data.labels
                          && calcs[pageNumber as keyof typeof calcs].map((calc: number) => <td style={{ textAlign: 'right' }} key={calc}>{formatNumber(value[1][`calc${calc}`], data.labels[`calc${calc}`].unit === '円' ? '¥' : '', data.labels[`calc${calc}`].unit === '円' ? '' : data.labels[`calc${calc}`].unit)}</td>)
                      }
                  </tr>
                ))
            }
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default ReportAllCard;
